var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { client as apiClient } from './client';
/** The catalog of selectable scripts (the game's weapons) + admin-added rows. */
export function getScripts() {
    return __awaiter(this, void 0, void 0, function* () {
        return apiClient.get('/scripts');
    });
}
export function createScript(data) {
    return __awaiter(this, void 0, void 0, function* () {
        return apiClient.post('/scripts', data);
    });
}
export function updateScript(id, data) {
    return __awaiter(this, void 0, void 0, function* () {
        return apiClient.patch(`/scripts/${id}`, data);
    });
}
export function deleteScript(id) {
    return __awaiter(this, void 0, void 0, function* () {
        yield apiClient.delete(`/scripts/${id}`);
    });
}
export function restoreScript(id) {
    return __awaiter(this, void 0, void 0, function* () {
        yield apiClient.patch(`/scripts/${id}/restore`);
    });
}
export function deleteScriptPermanently(id) {
    return __awaiter(this, void 0, void 0, function* () {
        yield apiClient.delete(`/scripts/${id}/permanent`);
    });
}
